import React from 'react'
import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from 'recharts'
import ChartTooltip from './ChartTooltip'

const GRID_STYLE = {strokeDasharray: '3 3', stroke: '#f0f0f0', horizontal: true, vertical: false}
const AXIS_TICK = {fontSize: 11, fontWeight: 500, fill: '#637381'}
const LEGEND_STYLE = {fontSize: 12, fontWeight: 500}

export function BarChart({data, xKey = 'name', yKey = 'value', color = '#1565c0', height = 300, colors, tooltipContent, chartOptions}) {
  if (chartOptions && chartOptions.data) {
    const xAxis = chartOptions.xaxis || xKey
    return (
      <ResponsiveContainer width='100%' height={height}>
        <RechartsBarChart data={data} margin={{top: 10, right: 20, left: 0, bottom: 5}} barGap={4}>
          <CartesianGrid {...GRID_STYLE} />
          <XAxis dataKey={xAxis} tick={AXIS_TICK} axisLine={{stroke: '#e2e8f0'}} tickLine={false} />
          <YAxis tick={AXIS_TICK} axisLine={false} tickLine={false} unit={chartOptions.data[0]?.unit || ''} />
          <Tooltip content={<ChartTooltip />} cursor={{fill: 'rgba(0,0,0,0.03)'}} />
          <Legend wrapperStyle={LEGEND_STYLE} iconType='square' iconSize={10} />
          {chartOptions.data.map((series) => (
            <Bar
              key={series.dataKey}
              dataKey={series.dataKey}
              name={series.label || series.dataKey}
              fill={series.fill || series.color || '#1565c0'}
              radius={[4, 4, 0, 0]}
              barSize={18}
              animationDuration={800}
              animationEasing='ease-out'
            />
          ))}
        </RechartsBarChart>
      </ResponsiveContainer>
    )
  }

  return (
    <ResponsiveContainer width='100%' height={height}>
      <RechartsBarChart data={data} margin={{top: 10, right: 20, left: 0, bottom: 5}}>
        <CartesianGrid {...GRID_STYLE} />
        <XAxis dataKey={xKey} tick={AXIS_TICK} axisLine={{stroke: '#e2e8f0'}} tickLine={false} />
        <YAxis tick={AXIS_TICK} axisLine={false} tickLine={false} />
        <Tooltip content={tooltipContent || <ChartTooltip />} cursor={{fill: 'rgba(0,0,0,0.03)'}} />
        <Bar dataKey={yKey} radius={[4, 4, 0, 0]} animationDuration={800} animationEasing='ease-out'>
          {data?.map((entry, index) => (
            <Cell key={index} fill={colors ? colors[index % colors.length] : color} />
          ))}
        </Bar>
      </RechartsBarChart>
    </ResponsiveContainer>
  )
}

export function VerticalBarChart({data, xKey = 'name', yKey = 'value', color = '#1565c0', height = 300, colors, tooltipContent, chartOptions}) {
  if (chartOptions && chartOptions.data) {
    const yAxis = chartOptions.xaxis || xKey
    return (
      <ResponsiveContainer width='100%' height={height}>
        <RechartsBarChart data={data} layout='vertical' margin={{top: 10, right: 20, left: 10, bottom: 5}} barGap={4}>
          <CartesianGrid strokeDasharray='3 3' stroke='#f0f0f0' horizontal={false} />
          <XAxis type='number' tick={AXIS_TICK} axisLine={{stroke: '#e2e8f0'}} tickLine={false} unit={chartOptions.data[0]?.unit || ''} />
          <YAxis type='category' dataKey={yAxis} tick={{...AXIS_TICK, width: 100}} width={110} axisLine={false} tickLine={false} />
          <Tooltip content={<ChartTooltip />} cursor={{fill: 'rgba(0,0,0,0.03)'}} />
          <Legend wrapperStyle={LEGEND_STYLE} iconType='square' iconSize={10} />
          {chartOptions.data.map((series) => (
            <Bar
              key={series.dataKey}
              dataKey={series.dataKey}
              name={series.label || series.dataKey}
              fill={series.fill || series.color || '#1565c0'}
              radius={[0, 4, 4, 0]}
              barSize={16}
              animationDuration={800}
              animationEasing='ease-out'
            />
          ))}
        </RechartsBarChart>
      </ResponsiveContainer>
    )
  }

  return (
    <ResponsiveContainer width='100%' height={height}>
      <RechartsBarChart data={data} layout='vertical' margin={{top: 10, right: 20, left: 10, bottom: 5}}>
        <CartesianGrid strokeDasharray='3 3' stroke='#f0f0f0' horizontal={false} />
        <XAxis type='number' tick={AXIS_TICK} axisLine={{stroke: '#e2e8f0'}} tickLine={false} />
        <YAxis type='category' dataKey={xKey} tick={{...AXIS_TICK, width: 100}} width={110} axisLine={false} tickLine={false} />
        <Tooltip content={tooltipContent || <ChartTooltip />} cursor={{fill: 'rgba(0,0,0,0.03)'}} />
        <Bar dataKey={yKey} radius={[0, 4, 4, 0]} animationDuration={800} animationEasing='ease-out'>
          {data?.map((entry, index) => (
            <Cell key={index} fill={colors ? colors[index % colors.length] : color} />
          ))}
        </Bar>
      </RechartsBarChart>
    </ResponsiveContainer>
  )
}
